import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import tableDataQueryStringBuilder from 'services/Utilities/TableData';

const buildQuartersUrl = tableDataParams => {
  if (!tableDataParams) {
    return `${HOST}/api/certification-tool/quarters`;
  }

  const queryString = tableDataQueryStringBuilder(tableDataParams);
  return `${HOST}/api/certification-tool/quarters?${queryString}`;
};

export const useQuarters = (tableDataParams = null, queryOptions = {}) => {
  return useQuery({
    queryKey: ['quarters', tableDataParams],
    queryFn: async () => {
      const url = buildQuartersUrl(tableDataParams);
      const response = await axios.get(url);
      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    ...queryOptions,
  });
};

export const useCurrentQuarter = () => {
  return useQuery({
    queryKey: ['currentQuarter'],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/certification-tool/quarters/current`);
      return response.data;
    },
  });
};

export default {
  useQuarters,
};
